import container from 'components/AuthenticationAction/SignOut/container';

import SignOutButton from './SignOutButton';

export default container(SignOutButton);
